// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"2bb16732","208":"08adccac","236":"fb845185","353":"cc59c6e3","512":"401a0d41","549":"980c070c","813":"ac614508"}[chunkId] + ".chunk.js";
};